var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPephubBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 72,
    viewBox: "0 0 280 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 56,
    height: 56,
    rx: 12,
    fill: "#EEF2FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 13,
    height: 36,
    rx: 4,
    fill: "#3B63F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 21,
    width: 9,
    height: 4,
    rx: 2,
    fill: "white",
    opacity: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 28,
    width: 9,
    height: 4,
    rx: 2,
    fill: "white",
    opacity: 0.65
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 35,
    width: 9,
    height: 4,
    rx: 2,
    fill: "white",
    opacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 18,
    width: 13,
    height: 44,
    rx: 4,
    fill: "#F76F6F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 21,
    width: 9,
    height: 4,
    rx: 2,
    fill: "white",
    opacity: 0.9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 28,
    width: 9,
    height: 4,
    rx: 2,
    fill: "white",
    opacity: 0.65
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 35,
    width: 9,
    height: 4,
    rx: 2,
    fill: "white",
    opacity: 0.9
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 42,
    width: 9,
    height: 4,
    rx: 2,
    fill: "white",
    opacity: 0.4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18,
    width: 10,
    height: 26,
    rx: 4,
    fill: "#2EC4B6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 21,
    width: 6,
    height: 4,
    rx: 2,
    fill: "white",
    opacity: 0.9
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 28,
    width: 6,
    height: 4,
    rx: 2,
    fill: "white",
    opacity: 0.65
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 44,
    fontFamily: "'Segoe UI', system-ui, sans-serif",
    fontSize: 28,
    fontWeight: 700,
    letterSpacing: -0.5
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B63F7"
  }, "Pep"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#1A2340"
  }, "Hub"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 58,
    fontFamily: "'Segoe UI', system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#8896B3",
    letterSpacing: 3
  }, "BOARDS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPephubBoard);
export default __webpack_public_path__ + "static/media/pephub-board.fca9cef5f58b8e4935be4a4ec1dd4c7d.svg";
export { ForwardRef as ReactComponent };